import { render, staticRenderFns } from "./HolidayManagement.vue?vue&type=template&id=fc88cea6"
import script from "./HolidayManagement.vue?vue&type=script&lang=js"
export * from "./HolidayManagement.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/general-datatable-page.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports